/* Mitch Dowd - header nav: arrow opens the dropdown, word goes to the category (Impact theme)

   Before: each top-level item (Men / Women / Kids / Gifts / Sale) is a
   <summary data-url="/collections/men"> inside <details is="mega-menu-disclosure">.
   With a mouse the theme (DropdownDisclosure._onSummaryClicked, trigger="hover")
   cancels the click and navigates to data-url, so clicking the little arrow took
   you to the category too. With touch (pointer: coarse) the trigger is "click":
   a tap only toggled the dropdown and never navigated at all.

   After:
   - click the arrow (the <svg> in the summary) -> open the dropdown, never navigate.
     Mouse: it is already open from hover, so it simply stays open. Touch: toggles.
   - click the word -> go to the category (mouse and touch).
   - keyboard Enter/Space on the focused summary behaves like clicking the word.
   The arrow's tap target is also enlarged (the svg is only 10x7px) using padding
   cancelled out by an equal negative margin, so nothing moves.

   Capture-phase listener on document, so it runs before the theme's own handler on
   the summary; stopImmediatePropagation keeps that handler from also firing.
   If the theme ever changes the summary markup (no svg / no data-url) this does
   nothing and the theme's own behaviour applies. */
(function () {
    'use strict';
    if (window.__mdNavArrow) return;
    window.__mdNavArrow = true;

    var style = document.createElement('style');
    style.textContent =
        'header details[is="mega-menu-disclosure"] > summary[data-url] > svg{' +
        'box-sizing:content-box;padding:10px 10px 10px 8px;margin:-10px -10px -10px -8px;cursor:pointer}';
    (document.head || document.documentElement).appendChild(style);

    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var summary = t.closest('header details[is="mega-menu-disclosure"] > summary[data-url]');
        if (!summary) return;
        var details = summary.parentElement;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (t.closest('svg')) {
            details.open = details.trigger === 'hover' ? true : !details.open;
        } else {
            window.location.href = summary.getAttribute('data-url');
        }
    }, true);
})();
